const doc = [({"en":({"models":({"team_survey_step":({"doesnt_belong_to_the_same_survey":"doesn't belong to the same survey: %{survey_name}"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;